import { api } from "@/boot/axios";
import { getAuthToken } from "@/boot/axios";
import type { BarganetsBase } from "@/interfaces/base";

export function useBase() {

  const getHomeContent = async () => {
    try {
      const response = await api.get<BarganetsBase>('/home', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return er
    }
  }

  return {
    getHomeContent
  }
}